import React from 'react';
import classNames from 'classnames';
// eslint-disable-next-line import/no-extraneous-dependencies
import shortid from 'shortid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import { AssignmentType } from '../../../../enums/assignmentType';
import { startEndTimeDisplay, formatHours } from '../../../../utils/dates';

export default function ClinicianAssignedVisits({ clinician }) {
  const clinicianAssignedVisits = clinician.assignments.filter(
    assignment => assignment.assignmentType === AssignmentType.PatientAssignment,
  );

  if (clinicianAssignedVisits.length === 0) return null;

  const visitDisplay = visit => {
    const percentOfWidth = (visit.visitTime.actual.duration / clinician.assignedVisitsTimeWithoutDrivingTime) * 100;
    const barClass = classNames('filledBar', {
      'amber-bar': percentOfWidth < 20,
      'blue-bar': percentOfWidth >= 20,
    });
    return (
      <ListItem className="assigned-visits-bars" key={shortid.generate()}>
        <Grid container>
          <Grid item xs={12}>
            <h4 className="patient-name">{visit.secondaryLabel}</h4>
          </Grid>
          <Grid item xs={10}>
            <div className="assignedVisitBar">
              <div className={barClass} style={{ width: `${percentOfWidth}%` }}>
                {formatHours(
                  visit.actualOccurance.actual.duration
                    ? visit.actualOccurance.actual.duration
                    : visit.visitTime.actual.duration,
                )}
              </div>
            </div>
          </Grid>
          <Grid className="visits-time" item xs={2}>
            {startEndTimeDisplay(
              visit.actualOccurance.actual.startDate
                ? visit.actualOccurance.actual.startDate
                : visit.visitTime.actual.startDate,
              visit.actualOccurance.actual.endDate
                ? visit.actualOccurance.actual.endDate
                : visit.visitTime.actual.endDate,
            )}
          </Grid>
        </Grid>
      </ListItem>
    );
  };
  return (
    <div className="clinician-info-box" id="clinician-assigned-visits">
      <h6>Assigned Visits</h6> <List>{clinicianAssignedVisits.map(visitDisplay)}</List>
    </div>
  );
}
